import Vue from "vue"
import modal from "./requirementModal.vue"

const requireModalConstructor = Vue.extend(modal)
let exist = false

let removeDom = event => {
  // console.log("removed")
  exist = false
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

// requireModalConstructor.prototype.close = function () {
//   exist = false
//   this.$el.addEventListener('beforeDestroy', removeDom);
//   this.closed = true;
// };

let getAnInstance = () => {
  // exist = true
  return new requireModalConstructor({
    el: document.createElement('div')
  })
}


let Requirement = (options = { mobile: '', company: '', movie: '', contact_mobile: '' }) => {
  // if (exist) {
  //   return
  // }
  let instance = getAnInstance();
  instance.visible = true
  //deploy options config
  instance.mobile = options.mobile;
  instance.contact = options.contact_mobile;
  instance.company = options.company;
  instance.movie = options.movie;
  instance.$el.addEventListener('beforeDestroy', removeDom);

  document.body.appendChild(instance.$el);

}

export default Requirement
